import { Badge } from './ui/badge';
import { formatStatusLabel } from '@/lib/format';

export type EntityType =
  | 'tenant'
  | 'salesforce_org'
  | 'telephony_connection'
  | 'phone_number'
  | 'call'
  | 'portal_user'
  | 'provider';

type StatusVariant = 'default' | 'secondary' | 'destructive' | 'success' | 'warning' | 'outline';

const STATUS_MAP: Record<string, StatusVariant> = {
  active: 'success',
  completed: 'success',
  operational: 'success',
  production: 'default',
  sandbox: 'secondary',
  invited: 'secondary',
  pending: 'warning',
  inactive: 'secondary',
  disconnected: 'secondary',
  disabled: 'secondary',
  archived: 'secondary',
  error: 'destructive',
  failed: 'destructive',
  failure: 'destructive',
  outage: 'destructive',
  suspended: 'warning',
  ringing: 'warning',
  initiated: 'warning',
  in_progress: 'warning',
  not_synced: 'warning',
  warning: 'warning',
};

export type StatusBadgeProps = {
  status: string;
  entity?: EntityType;
  size?: 'sm' | 'md';
  showIcon?: boolean;
};

/** Maps schema status enums to consistent badge variants and domain labels. */
export function StatusBadge({ status, entity, size = 'md' }: StatusBadgeProps) {
  const key = status.toLowerCase();
  const variant =
    entity === 'salesforce_org' && key === 'active'
      ? 'success'
      : (STATUS_MAP[key] ?? 'outline');
  return (
    <Badge variant={variant} className={size === 'sm' ? 'text-[10px] px-2 py-0' : undefined}>
      {formatStatusLabel(status, entity)}
    </Badge>
  );
}
